import { Component, OnInit } from '@angular/core';
import { PAGES_AND_PATHS } from '../../../constants/pages-and-paths';
import { AuthenticationHttpService } from '../../../services/http-services/authentication/authentication-http.service';
import { ActivatedRoute } from '@angular/router';
import {
  AbstractControl,
  FormBuilder,
  FormGroup,
  ValidationErrors,
  ValidatorFn,
  Validators,
} from '@angular/forms';

@Component({
  selector: 'tl-temporally-reset-password',
  templateUrl: './temporally-reset-password.page.html',
})
export class TemporallyResetPasswordPage implements OnInit {
  isSpinnerActive = false;
  formTriedToSubmit = false;
  isPasswordVisible = false;
  isConfirmPasswordVisible = false;
  submitError = false;
  passwordChanged = false;
  resetPasswordForm!: FormGroup;

  protected readonly PAGES_AND_PATHS = PAGES_AND_PATHS;
  constructor(
    private formBuilder: FormBuilder,
    private activatedRoute: ActivatedRoute,
    private authHttpService: AuthenticationHttpService
  ) {}

  ngOnInit(): void {
    this.buildForm();

    this.activatedRoute.params.subscribe((res: any) => {
      if (res.token) {
        this.resetPasswordForm.controls['verification_password'].patchValue(
          res.token
        );
      }
      if (res.userId) {
        this.resetPasswordForm.controls['user_id'].patchValue(res.userId);
      }
    });
  }

  buildForm(): void {
    this.resetPasswordForm = this.formBuilder.group({
      user_id: ['', [Validators.required]],
      password: ['', [Validators.required, Validators.minLength(8)]],
      password_confirmation: ['', [Validators.required]],
      verification_password: ['', [Validators.required]],
    });

    this.resetPasswordForm.addValidators(
      this.matchFields('password', 'password_confirmation')
    );
  }

  matchFields(fieldToMatch: string, fieldToValidate: string): ValidatorFn {
    return (formGroup: AbstractControl): ValidationErrors | null => {
      const controlToMatch = formGroup.get(fieldToMatch);
      const controlToValidate = formGroup.get(fieldToValidate);

      if (!controlToMatch || !controlToValidate) return null;

      if (controlToMatch.value !== controlToValidate.value) {
        controlToValidate.setErrors({ mustMatch: true });
        return { mustMatch: true };
      } else {
        if (controlToValidate.hasError('mustMatch')) {
          controlToValidate.setErrors(null);
        }
        return null;
      }
    };
  }

  onSubmit(): void {
    if (this.resetPasswordForm.valid) {
      this.formTriedToSubmit = true;
      this.isSpinnerActive = true;
      this.authHttpService
        .resetPasswordDeepLink(this.resetPasswordForm.value)
        .then((res: any) => {
          this.isSpinnerActive = false;
          this.formTriedToSubmit = false;
          this.passwordChanged = true;
        })
        .catch(
          ({ error }: { error: { errors: { [key: string]: string } } }) => {
            this.isSpinnerActive = false;
            this.formTriedToSubmit = false;

            this.submitError = true;
          }
        );
    }
  }
}
